<template>
  <div class="offcanvas-body">
    <LoadingContainer v-if="isPending" />
    <CheckboxInput :options="approachOptions" :model="approachesModel" />
  </div>
  <div class="offcanvas-footer">
    <FormButton
      :marginVertical="false"
      label="Concluir"
      :loading="submitting"
      @onClick="submit"
      :disabled="!meta.valid"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { approachesSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useApproaches } from "@/composables/useSettings";
import { useUpdateUser } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { approaches: allApproaches, isPending } = useApproaches();

const { handleSubmit, meta, resetForm } = useForm({
  validationSchema: toTypedSchema(approachesSchema),
  initialValues: { approaches: [] },
});

const approachesModel = useVeeField<number[]>("approaches");

onMounted(() => {
  resetForm({
    values: {
      approaches:
        session.value?.approaches.map((a: any) => a.approach_id) ?? [],
    },
  });
});

const approachOptions = computed(() =>
  allApproaches.value.map((a) => ({
    ...a,
    name: a.title,
    selected: approachesModel.$model.includes(a.id),
  })),
);

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, approaches: values.approaches });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});
</script>
